import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { NASProductCategory } from '@websky/graphql';
import { useTheme } from '../../../../theme';
import { GdsAggregationServiceGroup } from '../../../../Checkout/types';
import WrappedCommonCard from '../CommonCard/WrappedCommonCard';
import { getNasServiceCardParams } from '../utils';

interface Props {
	segmentId?: string;
	service: GdsAggregationServiceGroup;
}

const FastTrack: React.FC<Props> = ({ segmentId, service }) => {
	const { t } = useTranslation('Checkout');
	const { t: aasT } = useTranslation('ServiceAggregation');
	const theme = useTheme('CheckoutAdditionalService').FastTrack;

	const params = getNasServiceCardParams(NASProductCategory.fast_track);

	return (
		<WrappedCommonCard
			category={NASProductCategory.fast_track}
			header={t(params.title)}
			service={service}
			description={t(params.description)}
			coverClassName={theme.fast_track_aggregator}
			icons={params.icons}
			segmentId={segmentId}
		>
			{aasT('Pass through post with label Fast Track with your ticket')}
		</WrappedCommonCard>
	);
};

export default FastTrack;
